export enum UserRole {
  ADMIN = "ADMIN",
  USER = "USER",
  MANAGER = "MANAGER",
  SUPER_ADMIN = "SUPER_ADMIN",
  STAFF = "STAFF",
  GUEST = "GUEST",
}
export enum DepartmentCode {
  HR = "HR",
  RND = "RND",
  SALE = "SALE",
  SALE_ADMIN = "SALE_ADMIN",
  MKT = "MKT",
  WH = "WH",
  QC = "QC",
  ACC = "ACC",
  PD = "PD",
  LOG = "LOG",
  PUR = "PUR",
  FAE = "FAE",
  CEO = "CEO",
}
export enum PositionCode {
  WH_MANAGER = "WH_MANAGER",
  QC_MANAGER = "QC_MANAGER",
  PD_MANAGER = "PD_MANAGER",
  LOG_MANAGER = "LOG_MANAGER",
  ACC_MANAGER = "ACC_MANAGER",
  FAE_MANAGER = "FAE_MANAGER",
  PUR_MANAGER = "PUR_MANAGER",
  SALE_DIRECTOR = "SALE_DIRECTOR",
  SALE_MANAGER = "SALE_MANAGER",
  SALE_ADMIN_MANAGER = "SALE_ADMIN_MANAGER",
  HR_MANAGER = "HR_MANAGER",
  MKT_DIRECTOR = "MKT_DIRECTOR",
  MKT_MANAGER = "MKT_MANAGER",
  RND_MANAGER = "RND_MANAGER",
  CEO = "CEO",
  PD_LEAD = "PD_LEAD",
  LOG_LEADER = "LOG_LEADER",
  ACC_LEADER = "ACC_LEADER",
  PUR_LEADER = "PUR_LEADER",
  SALE_LEADER = "SALE_LEADER",
  SALE_ADMIN_LEADER = "SALE_ADMIN_LEADER",
  HR_LEADER = "HR_LEADER",
  RND_LEAD = "RND_LEAD",
  MANAGER = "MANAGER",
}
